"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.apiKeysSelectors = void 0;
var _status = require("./status");
const all = state => state.apiKeys;
const status = state => all(state).status;
const isLoading = state => status(state) === _status.apiKeysStatus.PENDING;
const isError = state => status(state) === _status.apiKeysStatus.ERROR;
const isLoggedIn = state => status(state) === _status.apiKeysStatus.SUCCESS;
const accessToken = state => all(state).accessToken;
const refreshToken = state => all(state).refreshToken;
const user = state => all(state).user;
const popupSeen = state => all(state).popupSeen;
const stripeConfig = state => all(state).stripeConfig;
const apiKeysSelectors = exports.apiKeysSelectors = {
  status,
  isLoading,
  isError,
  isLoggedIn,
  accessToken,
  refreshToken,
  user,
  popupSeen,
  stripeConfig
};